import React, { useState, useLayoutEffect } from "react";
import FadingScreen from "./FadingScreen";
import TopMenu from "../Menu/TopMenu";
import Footer from "./Footer";
import Products from "../Global/Products";

// Detecting ViewPort's width
function useWindowSize() {
  const [size, setSize] = useState(0);
  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

function Starter() {
  // x is width of ViewPort or Window
  const width = useWindowSize();
  var obj = { width };
  var myJSON = JSON.stringify(obj);
  let k = myJSON.substr(9, 11);
  let x = parseFloat(k);
  // finding where to change Opacity in FadingScreen Component
  const handleOpacity1 = () => {
    if (x < 740) {
      return 240;
    } else {
      return 400;
    }
  };
  const handleOpacity2 = () => {
    if (x < 740) {
      return 970;
    } else {
      return 1100;
    }
  };
  const handleScrollYDir = () => {
    if (x > 740) {
      if (!show) {
        if (window.pageYOffset > 630) {
          setShow(true);
        }
      }
    } else {
      if (!show) {
        if (window.pageYOffset > 480) {
          setShow(true);
        }
      }
    }
  };
  // List of Products and Services
  const DanceList = [
    {
      id: "dance1",
      stars: "3",
      description: "Online Dancing Class",
      name: "Jazz"
    },
    { id: "dance2", stars: "5", description: "Classic", name: "Tango" },
    {
      id: "dance3",
      stars: "2",
      description: "For Teenagers",
      name: "Ballet"
    },
    { id: "dance4", stars: "5", description: "All Ages", name: "Zumba" }
  ];
  const ProductList = [
    {
      id: "product1",
      stars: 1,
      description: "All kinds of skin",
      name: "Skin Cream"
    },
    {
      id: "product2",
      stars: 4,
      description: "Classy",
      name: "Lipstick"
    },
    {
      id: "product3",
      stars: "3",
      description: "Old Ladies",
      name: "Eye Cream"
    },
    {
      id: "product4",
      stars: "5",
      description: "Young Ladies",
      name: "Eye Cream"
    }
  ];

  const handleScrollXDir = e => {
    if (x > 740) {
      if (e.target.scrollLeft > 100) {
        setDarken("fade-out");
      } else {
        setDarken("fade-in");
      }
    } else {
      if (e.target.scrollLeft > 25) {
        setDarken("fade-out");
      } else {
        setDarken("fade-in");
      }
    }
    console.log("darken", darken);
    console.log("scroll", e.target.scrollLeft);
  };

  const [show, setShow] = React.useState(false);
  const [lastYPos, setLastYPos] = React.useState(0);
  const [darken, setDarken] = React.useState("fade-in");
  console.log("window.pageYOffset", window.pageYOffset);
  // Activating Scrolling datas
  React.useEffect(() => {
    function handleScroll() {
      const yPos = window.scrollY;

      setLastYPos(yPos);
    }

    window.addEventListener("scroll", handleScroll, false);

    return () => {
      window.removeEventListener("scroll", handleScroll, false);
    };
  }, [lastYPos]);
  // ////////////////////////////////////

  return (
    <div className="cover">
      <TopMenu />

      <FadingScreen subject="beauty" yPosition={handleOpacity1()} />

      <div onScroll={e => handleScrollXDir(e)} className="insider">
        <div className={darken}>
          <b className="bold-title">
            Discover <br />
            Our <br />
            Beauty Products
          </b>
        </div>

        {ProductList.map((ProductList, index) => {
          return (
            <Products
              key={index}
              product={ProductList.id}
              stars={ProductList.stars}
              description={ProductList.description}
              name={ProductList.name}
            />
          );
        })}
        <div className="empty"></div>
      </div>
      {handleScrollYDir()}

      <div className="fitness-container">
        {show ? (
          <FadingScreen subject="fitness" yPosition={handleOpacity2()} />
        ) : null}
      </div>

      <div
        onScroll={e => handleScrollXDir(e)}
        style={{
          marginTop: "0",
          padding: "0"
        }}
        className="insider"
      >
        <div
          style={{ marginTop: "-150px", paddingTop: "0" }}
          className={darken}
        >
          <b className="bold-title">
            Find <br />
            Where Your Heart <br />
            Truly Lies
          </b>
        </div>

        {DanceList.map((DanceList, index) => {
          return (
            <Products
              key={index}
              product={DanceList.id}
              stars={DanceList.stars}
              description={DanceList.description}
              name={DanceList.name}
            />
          );
        })}

        <div className="empty"></div>
      </div>
      <Footer />
    </div>
  );
}

export default Starter;
